import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom'

import repository from './repository';
import Quality from '@/componentes/quality';
import ComboStatus from '@/modules/admin/combos/status';
import Template from '@/modules/admin/template';

export function User() {

  const dataInitial = {
    status: true
  };

  const [list, setList] = useState([]);
  const [filters, setFilters] = useState(dataInitial);

  useEffect(() => {
    handleList();
  }, []);

  const handleList = (e) => {

    new Promise((resolve, reject) => {

      if (e !== undefined) {

        var params = {
          ...filters,
          [e.target.getAttribute('name')]: e.target.value
        };

        setFilters(params);

        resolve(params);
      }
      else {
        resolve({ ...filters });
      }

    }).then((result) => {

      repository.getList(result, (response) => {
        setList(response.data);
      });
    });
  }

  return (
    <>
      <Template title="Usuários">
        <div className="table_grid_filter">
          <div className="row">
            <div className="col-sm-3">Status</div>
          </div>
          <div className="row">
            <div className="col-sm-3">
              <ComboStatus handleList={handleList} />
            </div>
          </div>
        </div>
        <div className="table-responsive">
          <table className="table table-striped table_grid">
            <thead>
              <tr>
                <th>Cliente</th>
                <th>Grupo</th>
                <th>Usuario</th>
                <th>Login</th>
                <th>Status</th>
                <th className="option">
                  <Link to="/admin/users/form">
                    <button>Novo</button>
                  </Link>
                </th>
              </tr>
            </thead>
            <tbody>
              {list &&
                list.map((obj, index) => (
                  <tr key={index}>
                    <td>{obj.clientTitle}</td>
                    <td>{obj.groupTitle}</td>
                    <td>{obj.name}</td>
                    <td>{obj.login}</td>
                    <td><Quality value={obj.status} /></td>
                    <td className="option">
                      <Link to={`/admin/users/form/${obj.id}`}>
                        <button>Editar</button>
                      </Link>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </Template>
    </>
  )
}

export default User;